import { useState, useEffect, useCallback } from 'react';
import api from '../api/api';

export function useGames({ auto = true } = {}) {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const refresh = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get('/games');
            setGames(res.data ?? []);
            setError(null);
        } catch (e) {
            console.error('Fehler beim Laden der Spiele:', e);
            setError(e);
        } finally {
            setLoading(false);
        }
    }, []);

    const addGame = useCallback(async (name) => {
        const newGame = (name ?? '').trim();
        if (!newGame || games.includes(newGame)) return false;
        try {
            await api.post('/games', { game: newGame });
            setGames((prev) => [...prev, newGame]);
            return true;
        } catch (e) {
            console.error('Fehler beim Hinzufügen des Spiels:', e);
            return false;
        }
    }, [games]);

    useEffect(() => { if (auto) refresh(); }, [auto, refresh]);
    return { games, loading, error, refresh, addGame };
}

export function gamesToOptions(games) {
    return (games ?? []).map((g) => ({ label: g, value: g }));
}